import React from 'react'
import { useSelector } from 'react-redux'
import { IStore } from '../../../store/types'
import { useAppDispatch } from '../../../store'
import { deleteTemplate } from '../../../store/templates/actions'
import { ListTamplates } from '../../../components/Templates/ListTamplates'

export const OnlineListTamplates: React.FC = () => {
  const { templates } = useSelector((store: IStore) => store)
  const dispatch = useAppDispatch()

  const handleDelete = (id: number, calback?: () => void) => {
    dispatch(deleteTemplate(id)).then(calback)
  }

  return <ListTamplates groups={templates.groups} deleteTemplate={handleDelete} />
}
